<section
  class="power-reviews-detail-container"
  [ngClass]="isGuestUser ? 'guest' : ''"
>
  <h2 data-cy="pwr-product-details-title">
    {{ 'i18n.productDetail.ratings.title' | translate }}
  </h2>
  <div class="content">
    <div
      [id]="'pwr-product-details-reviews-' + productNumber"
      [attr.data-cy]="'pwr-product-details-reviews-' + productNumber"
    ></div>
  </div>
</section>
